import React, { ReactElement } from 'react';
import { Link } from '../ui/link';

import style from './style.module.scss';

import { ReactComponent as TelegramLogo } from '../../images/logo/telegram.svg';
import { ReactComponent as HSEInc } from '../../images/logo/hseinc.svg';
import { Logo } from '../ui/logo';

export const Footer = (): ReactElement => (
  <footer className={style.footer}>
    <Link href="https://t-do.ru/sl_do" className={style.support}>
      <TelegramLogo className={style.logo} />
      Помощь
    </Link>
    <Logo />
    <HSEInc />
  </footer>
);
